/**
 * 账号相关操作模块
 * */
import router from '@/router'


let userModel = {
	
	/**
	 * 跳转登录
	 * @returns {Promise<void>}
	 */
	async goLogin(url) {
		// 将路由fullpath 保存在缓存中，用于登录完成后跳转
        window.location.href = url;
	},

	async goBeforeLoginUrl(){
		let url = window.sessionStorage.getItem('beforeLoginUrl');
		if (!url || url.indexOf('/login') != -1) {
			router.push('/');
		} else {
			router.push(url);
			window.sessionStorage.setItem('beforeLoginUrl', '');
		}
	}
}

export default userModel
